import history from "./history";

export default function*() {
    yield* [...history];
}
